import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Historia from "@/pages/Historia";
import Ministerios from "@/pages/Ministerios";
import Sermones from "@/pages/Sermones";
import Eventos from "@/pages/Eventos";
import Donar from "@/pages/Donar";
import Contacto from "@/pages/Contacto";
import PaymentResult from "@/pages/PaymentResult";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-ink text-white font-sans">
          <div className="grain-overlay" aria-hidden="true" />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/historia" element={<Historia />} />
            <Route path="/ministerios" element={<Ministerios />} />
            <Route path="/sermones" element={<Sermones />} />
            <Route path="/eventos" element={<Eventos />} />
            <Route path="/donar" element={<Donar />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/payment/success" element={<PaymentResult type="success" />} />
            <Route path="/payment/cancel" element={<PaymentResult type="cancel" />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="top-center" />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
